import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";

export function initTeaserSliders() {
    const teaserSliders = document.querySelectorAll(".pul-teaser-slider .swiper");

    if (teaserSliders.length > 0) {
        for (const teaserSlider of teaserSliders) {
            const prevEl = teaserSlider.closest(".pul-teaser-slider").querySelector(".swiper-button-prev");
            const nextEl = teaserSlider.closest(".pul-teaser-slider").querySelector(".swiper-button-next");
            const slider = new Swiper(teaserSlider, {
                modules: [Navigation, Pagination],
                loop: true,
                slidesPerView: 1.375,
                spaceBetween: 16,
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15,
                pagination: {
                    el: ".swiper-pagination"
                },
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl
                },
                dragMinThreshold: {
                    mouse: 0,
                    touch: 10,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2.5
                    },
                    992: {
                        slidesPerView: 2.75
                    },
                    1200: {
                        slidesPerView: 2.25
                    },
                    1400: {
                        slidesPerView: 2.5
                    },
                    1600: {
                        slidesPerView: 2.55
                    },
                    1900: {
                        slidesPerView: 2.85
                    },
                    2000: {
                        slidesPerView: 4.5
                    }
                }
            });
        }
    }
}

export function initTeaserSlidersV2() {
    const teaserSliders = document.querySelectorAll(".pul-teaser-slider-2 .swiper");

    if (teaserSliders.length > 0) {
        for (const teaserSlider of teaserSliders) {
            const prevEl = teaserSlider.closest(".pul-teaser-slider-2").querySelector(".swiper-button-prev");
            const nextEl = teaserSlider.closest(".pul-teaser-slider-2").querySelector(".swiper-button-next");
            const slider = new Swiper(teaserSlider, {
                modules: [Navigation, Pagination],
                slidesPerView: 1.375,
                spaceBetween: 16,
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15,
                pagination: {
                    el: ".swiper-pagination"
                },
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl
                },
                dragMinThreshold: {
                    mouse: 0,
                    touch: 10,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2.5
                    },
                    992: {
                        slidesPerView: 2.75
                    },
                    1200: {
                        slidesPerView: 3.5
                    },
                    1600: {
                        slidesPerView: 4.25
                    },
                    2000: {
                        slidesPerView: 6
                    }
                },
                on: {
                    resize: (swiper) => {
                        if (window.matchMedia("(min-width: 1200px)").matches) {
                            swiper.params.slidesOffsetBefore = calculatePageOffset();
                            swiper.params.slidesOffsetAfter = calculatePageOffset();

                            swiper.update();
                        }
                    }
                }
            });
        }
    }
}

export function initTeaserSlidersV3() {
    const teaserSliders = document.querySelectorAll(".pul-teaser-slider-3 .swiper");

    if (teaserSliders.length > 0) {
        for (const teaserSlider of teaserSliders) {
            const prevEl = teaserSlider.closest(".pul-teaser-slider-3").querySelector(".swiper-button-prev");
            const nextEl = teaserSlider.closest(".pul-teaser-slider-3").querySelector(".swiper-button-next");
            const numberOfSlides = teaserSlider.querySelectorAll(".swiper-slide").length;

            const slider = new Swiper(teaserSlider, {
                modules: [Navigation, Pagination],
                loop: true,
                slidesPerView: 1.375,
                spaceBetween: 16,
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15,
                pagination: {
                    el: ".swiper-pagination"
                },
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl
                },
                dragMinThreshold: {
                    mouse: 0,
                    touch: 10,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1.5
                    },
                    768: {
                        slidesPerView: 2,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                    992: {
                        slidesPerView: 3,
                        loop: false,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                    1200: {
                        loop: false,
                        slidesPerView: 3,
                        spaceBetween: 95,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                },
                on: {
                    resize: (swiper) => {
                        if (window.matchMedia("(min-width: 992px)").matches && swiper.passedParams.breakpoints["992"].slidesPerView === numberOfSlides) {
                            swiper.el.closest(".pul-teaser-slider-3").classList.add("hide-arrows");
                        }
                    }
                }
            });
        }
    }
}

export function teaserSliderTextAnimation() {
    const LETTER_INTERVAL = 40; // ms delay between letters
    const INDEX_DIVIDER = 2;
    const teaserBlocks = document.querySelectorAll("[class^='pul-teaser-slider']");

    if (!teaserBlocks.length) return;

    teaserBlocks.forEach(teaserBlock => {
        const texts = teaserBlock.querySelectorAll("span[class^='pul-headline']");

        texts.forEach(text => {
            const letters = text.textContent.split("").map(letter => `<span class="animating">${letter}</span>`).join("");

            text.innerHTML = letters;

            const animatedLetters = teaserBlock.querySelectorAll(".animating");
            const observer = new IntersectionObserver(([entry], obs) => {
                if (entry.isIntersecting) {
                    animatedLetters.forEach((el, i) => {
                        setTimeout(() => {
                            el.classList.add("in-view");

                            if(i === animatedLetters.length - 1) {
                                teaserBlock.classList.add("completed");
                            }
                        }, (i / INDEX_DIVIDER) * LETTER_INTERVAL);
                    });

                    obs.unobserve(entry.target); // animate once
                }
            }, {
                threshold: window.matchMedia("(orientation: landscape)").matches ? 0.5 : 0.1,
            });

            observer.observe(teaserBlock);
        })
    });
}

function calculatePageOffset() {
    const containerMaxWidth = getComputedStyle(document.documentElement).getPropertyValue("--container-max-width").split("rem")[0] * 16;
    const containerOffset = (document.documentElement.clientWidth - containerMaxWidth + 30) / 2;

    return containerOffset;
}